import {
  useMutation,
  useQuery,
  useQueryClient,
  useSuspenseQuery,
} from "@tanstack/react-query";
import DragAndDrop from "components/drag-and-drop/drag-and-drop.component";
import Loading from "components/loading/loading.component";
import { CareerCategory } from "enums/glimps.enums";
import {
  IMyCareersPrioritize,
  IPrioritizeItem,
} from "interfaces/OnbaordingInterface";
import { ListPrioritize, prioritizeCareer } from "services/on-board";

interface PrioritizeComponentProps {
  showUnsortedError?: boolean;
}

const PrioritizeComponent: React.FC<PrioritizeComponentProps> = ({
  showUnsortedError,
}) => {
  const queryClient = useQueryClient();
  const {
    data: prioritizeListData,
    status: fetchStatus,
    refetch: refetchPrioritizeList,
  } = useQuery({
    queryKey: ["ListPrioritize"],
    queryFn: () => ListPrioritize(),
    retry: false,
    refetchOnWindowFocus: false,
  });

  const prioritizeDraggedCareer = useMutation({
    mutationFn: (data: IPrioritizeItem) => prioritizeCareer(data),
    retry: 0,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['ListPrioritize'] })
    }
  });

  return (
    <>
      <div className="px-5 pb-5 text-center">
        <h2 className="text-display-lg text-brand mb-1">
          Sort Each Career
        </h2>
        <p className="text-body text-text-muted">
          Drag and drop each career to sort them according to your preference.
          Each career must be sorted to move to the next step.
        </p>
      </div>
      {prioritizeListData?.length && fetchStatus === "success" ? (
        <DragAndDrop
          onDropped={(data: IMyCareersPrioritize, allList) => {
            const category = data?.category;
            if (!category) return;
            const categoryList = allList.filter((x) => x.category === category);
            const idx = categoryList.indexOf(data);
            return prioritizeDraggedCareer.mutateAsync({
              category,
              order: idx > 0 ? idx + 1 : 1,
              id: data.id,
            });
          }}
          displayUnsorted={true}
          data={prioritizeListData}
          showUnsortedError={showUnsortedError}
        />
      ) : (
        <Loading text="Loading Data" />
      )}
    </>
  );
};

export default PrioritizeComponent;
